"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDayOfMonthList = void 0;
const moment_1 = __importDefault(require("moment"));
const getDayList_1 = require("./getDayList");
const types_1 = require("../types");
const getDayOfMonthList = (month) => {
    const days = month === types_1.HEALTH_CHECK_MONTH_OF_YEAR.everyMonth ||
        month === types_1.HEALTH_CHECK_MONTH_OF_YEAR.everySelectedMonth
        ? 31
        : moment_1.default(`2022 ${month}`, 'YYYY MMMM').daysInMonth();
    return getDayList_1.getDayList(days);
};
exports.getDayOfMonthList = getDayOfMonthList;
//# sourceMappingURL=getDayOfMonthList.js.map